app.service('productDetailView', function (
	log,
	productCardConfig,
	main,
	productCardPhotos,
	productInteractionListener,
	searchResultCollector,
	searchBox,
	productNav,
	productTabList,
	productUpselling,
	productDetailSuccessorProduct,
	store,
	productDetailVariants,
	productRecommendations,
	productDetailPromotions,
	stickyHeader,
	autocompleteInfo,
	addToCartService,
	leaseLink,
	individualOfferHashChecker
) {
	let config;

	function init() {
		config = productCardConfig.getData();
		autocompleteInfo.logResult('product', config);
		initModules();
		logProductDetailPreview();
		setEvents();
	}

	function initModules() {
		store.init();
		stickyHeader.init();
		searchResultCollector.init('product', config.title);
		productUpselling.init();
		productCardPhotos.init();
		productNav.init();
		productTabList.init();
		productDetailSuccessorProduct.init();
		productDetailVariants.init();
		productRecommendations.init();
		productDetailPromotions.init();
		addToCartService.init();
		if(config.showLeaseLink){
			leaseLink.init();
		}
		scrollTabByHash();
		individualOfferHashChecker.check();
	}

	function logProductDetailPreview() {
		productInteractionListener.onProductCardView({
			id: config.id,
			plu: config.plu,
			groupId: config.groupId,
			groupName: config.groupName
		});

		log.visit({
			productId: config.id,
			productCode: config.plu,
			productsGroupId: config.groupId,
			productAvailabilityStatusCode: config.productAvailabilityStatusCode,
			keyword: searchBox.getKeyword() || undefined
		});

		log.recommendationsForAWS({
			productPlu: config.plu,
			eventCategory: 'KP',
			eventAction: 'Wejście na widok'
		});
	}

	function setEvents() {
		$('#product-main')
			.on('click', '.js-read-full-description', function onReadFullDescriptionClick() {
				$.scrollTo('[data-section-id=opis]');
			})
			.on('click', '.attribute-name a', function onAttributeNameClick() {
				UA.pageInteraction('Słownik', 'Cecha - ' + $.trim($(this).text()) + ' - ' + config.groupName);
			})
			.on('click', '.attribute-value a', function onAttributeValueClick() {
				UA.pageInteraction('Słownik', 'Wartość  - ' + $.trim($(this).text()) + ' - ' + config.groupName);
			})
			.on('click', '.stars-rating a:not(.rating-count)', function onStarsRatingClick() {
				UA.pageInteraction('Opinie', 'Gwiazdki nad foto');
			})
			.on('click', '.stars-rating a.rating-count', function onStarsRatingCountClick() {
				UA.pageInteraction('Opinie', 'Gwiazdki nad foto - Tekst');
			});

		$('body')
			.on('click', '.js-scroll-by-hash', function handleScrollByHashClick(e) {
				e.preventDefault();

				if ($(this).attr('href').split('#')[1] === window.location.href.split('#')[1]) {
					scrollTabByHash();
				} else {
					window.location = $(this).attr('href');
				}
			})
			.on('click', '.js-add-product-to-cart', function handleAddProductToCartClick() {
				addToCartService.add();
			});

		window.onbeforeprint = function addPrintDate() {
			const currentDate = new Date(Date.now()).toLocaleDateString();
			$('#print-info-date').find('span').html(currentDate);
		};

		$(window).on('hashchange', scrollTabByHash);
	}

	function scrollTabByHash() {
		const hash = document.location.hash;
		if (hash && productNav.isSectionAvailable(hash.slice(1))) {
			$.scrollTo(`[data-section-id=${hash.slice(1)}]`);
		}
	}

	main.onLoad(init);
});